// SWRV keeps the last answer of each key in its in-memory cache and serves it again,
// without asking, until the hook's dedupe interval has passed. After a 403 that copy is
// no longer the reader's to see (S5): the key's entry is dropped, so a page opened again
// shows the loader and asks the server, which answers with the current state (refusal,
// pending request, or the content given back). No `@/` import, so `node --test` can
// load this file directly.
import { mutate, SWRVCache } from 'swrv'

// The open pages are not told (an empty refs cache): they get the refusal itself.
const NO_OPEN_PAGES = new SWRVCache()

// SWRV has no delete: an entry stored with the smallest time-to-live is already expired
// when SWRV's cache checks it on the next timer tick, and is removed. (With 1 ms, that
// check can run a hair early and keep the entry.)
export async function cacheRefusal(key) {
    await mutate(key, null, undefined, Number.MIN_VALUE, NO_OPEN_PAGES)
}
